import * as S from "@dcspark/cardano-multiplatform-lib-nodejs";
import { JsToWasm, wasmToJs } from "./WasmSerialization";
export const forEachItem = (l, fn) => {
    for (let i = 0; i < l.len(); i++) {
        fn(l.get(i), i, l);
    }
};
export const reduceList = (l, fn, acc) => {
    forEachItem(l, (item, idx) => {
        acc = fn(acc, item, idx, l);
    });
    return acc;
};
export const forEachEntry = (m, fn) => {
    for (let i = 0; i < m.len(); i++) {
        const key = m.keys().get(i);
        fn(key, m.get(key), i, m);
    }
};
export const reduceMap = (m, fn, acc) => {
    forEachEntry(m, (key, value, idx) => {
        acc = fn(acc, key, value, idx, m);
    });
    return acc;
};
export const utxoWasmToJs = (utxo) => {
    return {
        ...wasmToJs(utxo.input()),
        ...wasmToJs(utxo.output()),
    };
};
export const utxoJsToWasm = ({ index, transaction_id, address, amount, datum_option, }) => {
    return S.TransactionUnspentOutput.new(JsToWasm.TransactionInput({ index, transaction_id }), JsToWasm.TransactionOutput({ address, amount, datum_option }));
};
export const bigNumToWasm = (big) => S.BigNum.from_str(String(big));
export const bigIntToWasm = (big) => S.BigInt.from_str(String(big));
export const intToWasm = (int) => S.Int.from_str(String(int));
export const bigToJs = (big) => BigInt(big.to_str());
//# sourceMappingURL=WasmSerialization.utils.js.map